<template>

    <div v-if="messages.length" class="" >
        <div class="toast show align-items-center text-white bg-danger border-0 position-relative" role="alert" aria-live="assertive" aria-atomic="true">
            <div class="d-flex">
                <div class="toast-body w-100">
                    <p class="mb-2">
                        <strong>
                            {{ title }}
                        </strong>
                    </p>
                    <p v-for="message in messages" :key="message" class="mb-0">{{ message }}</p>
                </div>
                <button 
                    type="button" 
                    class="btn-close btn-close-white position-absolute"
                    style="top: 10px; right: 10px;" 
                    data-bs-dismiss="toast" 
                    aria-label="Close"></button>
            </div>
        </div>
    </div>

</template>

<script>

    export default {
        props: {
            title: {
                type: String,
                required: true
            },
            messages: {
                type: Array,
                required: true
            }
        }
    }

</script>